"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarDivider_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarDivider_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdivider = require("@fluentui/react-divider");
const _ToolbarContext = require("../Toolbar/ToolbarContext");
const useToolbarDivider_unstable = (props, ref)=>{
    const vertical = (0, _ToolbarContext.useToolbarContext_unstable)((ctx)=>ctx.vertical);
    return (0, _reactdivider.useDivider_unstable)({
        vertical: !vertical,
        ...props
    }, ref);
};
